module.exports = "/_next/static/images/download-5e32ea298424e06cb9da4d1d79a0a256.png";